import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SubscriptionPlansPopover from '../MyProfileFeatures/SubscriptionPlansPopover';

const SubscriptionBilling = () => {
  const [showPopover, setShowPopover] = useState(false);

  return (
    <>
      <motion.div
        className="mx-auto w-[92%] max-w-5xl rounded-xl border border-gray-200 bg-white p-4 shadow-sm sm:w-full md:p-6"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="mb-4 flex items-center">
          <div className="mr-3 flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
            <svg
              className="h-5 w-5 text-blue-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <rect x="3" y="6" width="18" height="12" rx="3" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 10h18" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-black">Subscription & Billing</h2>
        </div>

        <p className="mb-6 text-sm text-black">
          View your current plan, update payment methods, and download invoices.
        </p>

        <div className="mb-8 rounded-lg border border-gray-200 bg-gray-50 p-4">
          <div className="mb-2 flex items-center justify-between">
            <div className="flex items-center">
              <svg
                className="mr-2 h-4 w-4 text-blue-600"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 17.75l-5.5 3.25 1.5-6.5-5-4.5 6.75-.5L12 3l2.25 6.5 6.75.5-5 4.5 1.5 6.5z"
                />
              </svg>
              <span className="text-sm font-medium text-black">Premium Plan</span>
            </div>
            <span className="text-xs font-medium text-green-600">Active</span>
          </div>
          <p className="mb-4 text-xs text-gray-500">
            Your subscription renews on <strong>May 1, 2025</strong>.
          </p>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => setShowPopover(true)}
            className="w-full rounded-lg bg-blue-600 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700"
          >
            Manage Subscription
          </motion.button>
        </div>

        <div className="mb-3 flex items-center justify-between">
          <span className="text-sm font-medium text-black">Recent Invoices</span>
          <a href="#" className="text-xs font-medium text-blue-600 hover:text-blue-700">
            View all
          </a>
        </div>

        {['April 2025', 'March 2025'].map(month => (
          <div
            key={month}
            className="mb-2 flex items-center justify-between rounded-lg bg-gray-50 p-3"
          >
            <div>
              <div className="text-sm font-medium text-black">{month}</div>
              <div className="text-xs text-gray-500">€49.99</div>
            </div>
            <a
              href="#"
              className="flex items-center text-xs font-medium text-blue-600 hover:text-blue-700"
            >
              <svg
                className="mr-1 h-3 w-3"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 16V8m0 0l-4 4m4-4l4 4" />
                <rect x="4" y="4" width="16" height="16" rx="4" />
              </svg>
              PDF
            </a>
          </div>
        ))}
      </motion.div>

      <AnimatePresence>
        {showPopover && <SubscriptionPlansPopover onClose={() => setShowPopover(false)} />}
      </AnimatePresence>

      <ToastContainer />
    </>
  );
};

export default SubscriptionBilling;
